@if (!loggedin()) {
<div class="container-fluid back-color p-0">
  <!-- <div class="container">
        <img src="assets/main-image/home-page-main-image-3.svg" width="100%" alt="">
    </div> -->
  <div class="p-2 home-page-title-background-img">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-12 mt-5 OUR-GAME">
          <div class="mt-5">
            <h1 class="Wel-come-to-New mt-5">Wel-come to New Era Chess</h1>
          </div>
          <div>
            <h1 class="Play-Chess-Online-on default-text mt-3">
              Play Chess Online on the
              <span class="No-1-platfor-text px-2">No.1 platform!</span>
            </h1>
          </div>
          <div>
            <p class="Creating-a-winning default-text mt-3">
              Welcome to ChessX – your ultimate destination for all things
              chess! Whether you're a beginner looking to learn the basics or an
              advanced player aiming to refine your strategy.
            </p>
          </div>

          <div class="row mt-5">
            <div class="col-md-6 justify-content-center d-flex">
              <div>
                <img
                  src="assets/icon-image/Play-Online-img-2.svg"
                  width="100%"
                  alt=""
                />
              </div>
              <div>
                <p class="mb-0 ms-3 Play-Online default-text">Play Online</p>
                <p class="ms-3 Play-with-someone default-text">
                  Play with someone at your level
                </p>
              </div>
            </div>

            <div class="col-md-6 d-flex justify-content-center">
              <div>
                <img
                  src="assets/icon-image/Play-Computer-img-2.svg"
                  width="100%"
                  alt=""
                />
              </div>
              <div>
                <p class="mb-0 ms-3 Play-Online default-text">Play Computer</p>
                <p class="ms-3 Play-vs-customizable default-text">
                  Play vs customizable training bots!
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-1"></div> -->

        <!-- <div class="col-md-12 col-xl-6 col-lg-12 col-sm-12">
                <div class="mt-5 text-center">
                    <img src="assets/main-image/OUR-GAME-PLAY-IMG-2.svg" width="100%" alt="" class="mt-3">
                </div>
            </div> -->
      </div>
    </div>
  </div>

  <div class="home-page-line"></div>

  <div class="container-fluid background-image-1 p-2">
    <div class="container">
      <div class="row align-items-center p-3">
        <div class="col-md-6">
          <div class="">
            <img
              src="assets/main-image/Take-Chess-Lessons-img.svg"
              width="90%"
              alt=""
            />
          </div>
          <div>
            <h1 class="New-Game mt-2">New Game</h1>
          </div>
          <div class="Solve-Puzzles-btn-btn">
            <button class="Solve-Puzzles-btn mt-4" (click)="loginuser()">
              Play Now!
            </button>
          </div>
        </div>

        <div class="col-md-1"></div>

        <div class="col-md-5 mt-4">
          <div class="card solve-puzzles" style="width: 100%">
            <div class="text-center mt-4">
              <img
                width="35%"
                src="assets/customer-image/Solve-Chess-Puzzles-boy-img.svg"
                alt="Card image cap"
              />
            </div>
            <div class="card-body">
              <h5 class="card-title text-center player-name">Magnus Carlsen</h5>
              <p class="card-text text-center players-review mt-3">
                “Self-confidence is very important. If you don't think you can
                win, you will not be able to win.”
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="home-page-line"></div>

  <div class="container-fluid background-image-2 p-2">
    <div class="container">
      <div class="row align-items-center p-3">
        <div class="col-md-5 mt-3">
          <div class="card solve-puzzles" style="width: 100%">
            <div class="text-center mt-4 mb-1">
              <img
                width="35%"
                src="assets/customer-image/Hikaru-Nakamura.jpg"
                alt="Card image cap"
              />
            </div>
            <div class="card-body">
              <h5 class="card-title text-center player-name">
                Hikaru Nakamura
              </h5>

              <p class="card-text text-center players-review mt-3">
                “Chess is really about the intricacies and the infinite
                possibilities that arise from the simplest of moves. Every game
                is a new story.”
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-1"></div>

        <div class="col-md-6">
          <div class="">
            <img
              src="assets/main-image/Solve-Chess-Puzzles-img.svg"
              width="90%"
              alt=""
            />
          </div>
          <div>
            <h1 class="Solve-Chess-Puzzles mt-3">Solve Chess Puzzles</h1>
          </div>
          <div class="Solve-Puzzles-btn-btn">
            <button class="Solve-Puzzles-btn mt-4" (click)="loginuser()">
              Solve Puzzles
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="home-page-line"></div>

  <div class="container-fluid background-image-3 p-2">
    <div class="container">
      <div class="row align-items-center p-3">
        <div class="col-md-6">
          <div class="">
            <img
              src="assets/main-image/Take-Chess-Lessons-img.svg"
              width="90%"
              alt=""
            />
          </div>
          <div>
            <h1 class="Take-Chess-Lessons mt-3">Take Chess Lessons</h1>
          </div>
          <div class="Solve-Puzzles-btn-btn">
            <button class="Solve-Puzzles-btn mt-4" (click)="loginuser()">
              Start Lessons
            </button>
          </div>
        </div>

        <div class="col-md-1"></div>

        <div class="col-md-5 mt-5">
          <div class="card solve-puzzles" style="width: 100%">
            <div class="text-center mt-4 mb-1">
              <img
                width="35%"
                src="assets/customer-image/Praggnanandhaa-in-chess.jpg"
                alt="Card image cap"
              />
            </div>
            <div class="card-body">
              <h5 class="card-title text-center player-name">Praggnanandhaa</h5>

              <p class="card-text text-center players-review mt-3">
                “Chess has taught me patience and the ability to think ahead. It
                has also taught me that there are no shortcuts to success.”
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}@else {

<div class="container-fluid main-box-bg-img my-5">
  <div class="">
    <div>
      <div class="home-line-img">
        <div class="home-profile-section">
          <div class="text-center">
            <h2>Welcome to ChessX</h2>
          </div>
          <div
            class="container d-flex justify-content-between selected-section-board p-0"
          >
            <p
              class="m-0 btn-section"
              [ngClass]="{ 'transparent-game-btn': gamesection }"
              (click)="gamesectiondata()"
            >
              Game
            </p>
            <!-- <p class=" m-0 btn-section" [ngClass]="{'transparent-btn': puzzlesection}" (click)="puzzlesectiondata()">Puzzle
              </p> -->
            <p
              class="m-0 btn-section"
              [ngClass]="{ 'transparent-profile-btn': profilesection }"
              (click)="profilesectiondata()"
            >
              Profile
            </p>
          </div>
          <div class="container game-form-show my-2">
            <div class="">
              @if(profilesection){
              <div class="d-flex flex-column">
                @if (userData) {
                <div
                  class="profile-main-box d-flex flex-row rounded justify align-items-center my-2 p-2 mw-100 b-none"
                >
                  <div class="card">
                    <div
                      class="card-box-set d-flex align-items-center justify-content-between"
                    >
                      <div class="d-flex align-items-center">
                        @if(userData.image){

                        <img
                          class="rounded m-2"
                          src="{{ userData.image }}"
                          alt="image"
                          style="width: 100px; height: 100px"
                        />
                        }@else {
                        <img
                          src="../../../../../../assets/customer-image/men-shadow.png"
                          style="width: 100px; height: 100px"
                          class="rounded-circle m-2"
                          alt="user image"
                        />
                        }
                        <div class="ms-1">
                          <p
                            class="m-0 username"
                            style="cursor: pointer"
                            (click)="profilememberDetails(userData.username)"
                          >
                            {{ userData.username }}
                          </p>
                          <p class="title m-0">
                            {{ userData.firstname }} {{ userData.lastname }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tile-container">
                    @for (tile of tiles; track $index) {
                    <div class="tile" [ngClass]="{ flip: tile.flip }">
                      <div class="front">
                        <div class="d-flex align-items-center mt-2">
                          <img
                            src="/assets/icon-image/blitz-img.svg"
                            class="me-2"
                            alt=""
                          />
                          <h5>{{ tile.blitz?.gameMode }}</h5>
                        </div>
                        <h5 class="text-center ranks">
                          #{{ tile.blitz?.Rank }}
                        </h5>
                        <h5 class="text-center rating">
                          {{ userData.ratings.blitz.last.rating }}
                        </h5>
                      </div>
                      <div class="back">
                        <p>
                          Win -
                          <span class="rating">{{
                            userData.ratings.blitz.record.win
                          }}</span>
                        </p>
                        <p>
                          Loss -
                          <span class="rating">{{
                            userData.ratings.blitz.record.loss
                          }}</span>
                        </p>
                        <p>
                          Draw -
                          <span class="rating">{{
                            userData.ratings.blitz.record.draw
                          }}</span>
                        </p>
                        <p>
                          winrate -
                          <span>{{ tile.winrate | number : "1.2-2" }}%</span>
                        </p>
                      </div>
                    </div>
                    } @for (tile of bullet; track $index) {
                    <div class="tile" [ngClass]="{ flip: tile.flip }">
                      <div class="front">
                        <div class="d-flex align-items-center mt-2">
                          <img
                            src="/assets/icon-image/bullet-img.svg"
                            class="me-2"
                            alt=""
                          />
                          <h5>{{ tile.bullet?.gameMode }}</h5>
                        </div>
                        <h5 class="text-center ranks">
                          #{{ tile.bullet?.Rank }}
                        </h5>
                        <h5 class="text-center rating">
                          {{ userData.ratings.bullet.last.rating }}
                        </h5>
                      </div>
                      <div class="back">
                        <p>
                          Win -
                          <span class="rating">{{
                            userData.ratings.bullet.record.win
                          }}</span>
                        </p>
                        <p>
                          Loss -
                          <span class="rating">{{
                            userData.ratings.bullet.record.loss
                          }}</span>
                        </p>
                        <p>
                          Draw -
                          <span class="rating">{{
                            userData.ratings.bullet.record.draw
                          }}</span>
                        </p>
                        <p>
                          winrate -
                          <span>{{ tile.winrate | number : "1.2-2" }}%</span>
                        </p>
                      </div>
                    </div>
                    } @for (tile of rapid; track $index) {
                    <div class="tile" [ngClass]="{ flip: tile.flip }">
                      <div class="front">
                        <div class="d-flex align-items-center mt-2">
                          <img
                            src="/assets/icon-image/rapid-img.svg"
                            class="me-2"
                            alt=""
                          />
                          <h5>{{ tile.rapid?.gameMode }}</h5>
                        </div>
                        <h5 class="text-center ranks">
                          #{{ tile.rapid?.Rank }}
                        </h5>
                        <h5 class="text-center rating">
                          {{ userData.ratings.rapid.last.rating }}
                        </h5>
                      </div>
                      <div class="back">
                        <p>
                          Win -
                          <span class="rating">{{
                            userData.ratings.rapid.record.win
                          }}</span>
                        </p>
                        <p>
                          Loss -
                          <span class="rating">{{
                            userData.ratings.rapid.record.loss
                          }}</span>
                        </p>
                        <p>
                          Draw -
                          <span class="rating">{{
                            userData.ratings.rapid.record.draw
                          }}</span>
                        </p>
                        <p>
                          winrate -
                          <span>{{ tile.winrate | number : "1.2-2" }}%</span>
                        </p>
                      </div>
                    </div>
                    } @for (tile of puzzles; track $index) {
                    <div class="tile">
                      <div class="front">
                        <div class="d-flex align-items-center mt-2">
                          <img
                            src="/assets/icon-image/rapid-img.svg"
                            class="me-2"
                            alt=""
                          />
                          <h5>{{ tile.puzzles?.gameMode }}</h5>
                        </div>
                        <h5 class="text-center ranks">
                          #{{ tile.puzzles?.Rank }}
                        </h5>
                        <h5 class="text-center rating">
                          {{ userData.ratings.puzzle.last.rating }}
                        </h5>
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              } @if (gamesection) {
              <div class="">
                <div class="d-flex justify-content-center mt-2">
                  <h2 class="mt-3 mb-0">Create Game</h2>
                </div>

                @if(opponentWaiting){
                <div class="opponent-Waiting mt-2">
                  <div class="p-3">
                    <div class="">
                      <div class="text-center">
                        <h4 class="m-0 box-paragraph-text">
                          {{ userData?.username }}
                        </h4>
                      </div>
                      <!-- <div class="d-flex justify-content-center mt-2">
                        <h6
                          class="m-0 box-paragraph-text text-center px-4 py-2 game-opponent-waiting-time"
                        >
                         
                        </h6>
                      </div> -->
                      <div class="d-flex justify-content-center mt-2">
                        <h6
                          class="m-0 box-paragraph-text text-center px-4 py-2 game-opponent-waiting-time"
                        >
                        {{ selectModeData?.selectedMode }} - {{ selectModeData?.selectedTime }}
                        </h6>
                      </div>
                      <div class="d-flex justify-content-center mt-2">
                        <div class="loader"></div>
                        <!-- <div
                          class="m-0 box-paragraph-text d-flex align-items-center"
                        >
                          Waiting for Opponent
                          <p class="loader ms-1"></p>
                        </div> -->
                      </div>
                      <div class="text-center">
                        <button
                          (click)="multiplayerclose()"
                          class="btn opponent-cancel-btn mt-2"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                }@else {
                <div class="main-form-section d-flex justify-content-center">
                  <form
                    [formGroup]="form"
                    (ngSubmit)="onSubmit(form.value)"
                    class="px-4 form-size py-2 main-form-section"
                  >
                    <div class="row">
                      <div class="form-group col-md-6">
                        <label for="modeSelect">Select Mode</label>
                        <select
                          id="modeSelect"
                          class="form-select"
                          formControlName="selectedMode"
                          (change)="onModeChange()"
                        >
                          <option value="" selected disabled>
                            Select a mode
                          </option>
                          <option value="blitz">Blitz</option>
                          <option value="rapid">Rapid</option>
                          <option value="bullet">Bullet</option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="timeSelect">Select a time</label>
                        <select
                          id="timeSelect"
                          class="form-select"
                          [disabled]="!showTimeOptions"
                          formControlName="selectedTime"
                        >
                          <option value="" selected disabled>
                            Select a time
                          </option>
                          @for (item of availableTimes; track $index) {
                          <option [value]="item">{{ item }}</option>
                          }
                        </select>
                      </div>
                    </div>
                    <div class="row align-items-center mt-2">
                      <div class="form-group col-md-4">
                        <label for="inputCity">Play as Side</label>
                        <select
                          id="inputCity"
                          class="form-select"
                          formControlName="selectedTurn"
                        >
                          <option value="" selected disabled>
                            Select a Side
                          </option>
                          <option value="W">White</option>
                          <option value="B">Black</option>
                          <option value="R">Random</option>
                        </select>
                      </div>

                      <div class="col-md-4">
                        <label class="form-check-label" for="ratings"
                          >Rating</label
                        >

                        <div class="form-check form-switch">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="ratings"
                            formControlName="switchState"
                          />
                        </div>
                      </div>

                      <div class="col-md-4 text-center">
                        <div
                          style="cursor: pointer; width: fit-content"
                          (click)="toggleAdvancedOptions()"
                        >
                          Custom @if(showAdvancedOptions){
                          <i class="fas fa-chevron-up"></i>
                          }@else {
                          <i class="fas fa-chevron-down"></i>
                          }
                        </div>
                      </div>
                    </div>

                    @if(showAdvancedOptions){
                    <div class="advanced-options">
                      <div class="row mt-2">
                        <div class="form-group col-md-6">
                          <label for="minRating">Minimum Rating</label>
                          <input
                            type="number"
                            id="minRating"
                            formControlName="minRating"
                            class="form-control"
                            placeholder="e.g. 200"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="maxRating">Maximum Rating</label>
                          <input
                            type="number"
                            id="maxRating"
                            formControlName="maxRating"
                            class="form-control"
                            placeholder="e.g. 1275"
                            [ngClass]="{
                              'is-invalid':
                                form.hasError('ratingRangeInvalid') &&
                                form.get('maxRating')?.touched
                            }"
                          />
                          <div
                            *ngIf="
                              form.hasError('ratingRangeInvalid') &&
                              form.get('maxRating')?.touched
                            "
                            class="invalid-feedback"
                          >
                            Maximum Rating must be greater than or equal to
                            Minimum Rating.
                          </div>
                        </div>
                      </div>

                      <div class="row mt-2">
                        <div class="form-group col-md-6">
                          <label for="board-style">Board Style</label>
                          <select
                            id="board-style"
                            formControlName="boardStyle"
                            class="form-select"
                          >
                            <option value="BI" class="option">Blue Ice</option>
                            <option value="Classic" class="option">
                              Classic
                            </option>
                            <option value="dr" class="option">
                              Dusty Rose
                            </option>
                            <option value="eo" class="option">
                              Electric Oasis
                            </option>
                            <option value="Barbie" class="option">
                              Barbie
                            </option>
                            <option value="Av" class="option">
                              Aqua Vintage
                            </option>
                            <option value="Urban Slate" class="option">
                              Urban Slate
                            </option>
                            <option value="Froggy" class="option">
                              Froggy
                            </option>
                            <option value="cs" class="option">Coral Sky</option>
                            <option value="green" class="option">Green</option>
                            <option value="Mint Breeze" class="option">
                              Mint Breeze
                            </option>
                            <option value="Cranberry Mist" class="option">
                              Cranberry Mist
                            </option>
                            <option value="ts" class="option">
                              Tranquil Sky
                            </option>
                          </select>
                        </div>
                        <div class="form-group col-md-6">
                          <label for="piece-style">Piece Style</label>
                          <select
                            id="piece-style"
                            formControlName="pieceStyle"
                            class="form-select"
                          >
                            <option value="wikipedia" class="option">
                              Wikipedia
                            </option>
                            <option value="alpha" class="option">Alpha</option>
                            <option value="squart" class="option">
                              Squart
                            </option>
                            <option value="forest" class="option">
                              Forest
                            </option>
                            <option value="fallout" class="option">
                              Fallout
                            </option>
                            <option value="monument" class="option">
                              Monument
                            </option>
                            <option value="faded" class="option">Faded</option>
                          </select>
                        </div>
                      </div>

                      <div class="row mt-2 align-items-center">
                        <div class="form-group col-md-6">
                          <label for="visibility">Game Visibility</label>
                          <select
                            id="visibility"
                            formControlName="visibility"
                            class="form-select"
                          >
                            <option value="private">Private</option>
                            <option value="public">Public</option>
                          </select>
                        </div>
                        <div class="col-md-3">
                          <label class="form-check-label" for="move-sounds"
                            >Move Sounds</label
                          >

                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="move-sounds"
                              formControlName="moveSounds"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    }

                    <div class="d-flex justify-content-center my-3">
                      <button
                        type="submit"
                        [disabled]="!form.valid"
                        class="btn btn-primary btn-section"
                      >
                        Challenge
                      </button>
                    </div>
                  </form>
                </div>
                }
              </div>
              }
            </div>
          </div>
        </div>

        <!-- <img src="" style="opacity: 0.5;" alt=""> -->

        <div class="home-box-section container pb-5">
          <div class="main-box-section">
            <div class="main-box" routerLink="play">
              <div class="d-grid justify-content-center">
                <div class="icon-box">
                  <i class="fa-solid fa-gamepad" style="color: #ffffff"></i>
                </div>
                <p class="m-0 mt-2 text-center">Play</p>
              </div>
            </div>
            <div class="main-box" routerLink="puzzle">
              <div class="d-grid justify-content-center">
                <div class="icon-box">
                  <i
                    class="fa-solid fa-puzzle-piece"
                    style="color: #ffffff"
                  ></i>
                </div>
                <p class="m-0 mt-2 text-center">Puzzle</p>
              </div>
            </div>
            <div class="main-box" routerLink="leaderboard">
              <div class="d-grid justify-content-center">
                <div class="icon-box">
                  <i class="fa-solid fa-chess-board" style="color: #ffffff"></i>
                </div>
                <p class="m-0 mt-2 text-center">Boards</p>
              </div>
            </div>
            <div class="main-box" routerLink="database">
              <div class="d-grid justify-content-center">
                <div class="icon-box">
                  <i class="fa-solid fa-landmark" style="color: #ffffff"></i>
                </div>
                <p class="m-0 mt-2 text-center">Record's</p>
              </div>
            </div>
            <div class="main-box" routerLink="openings">
              <div class="d-grid justify-content-center">
                <div class="icon-box">
                  <i class="fa-solid fa-disease" style="color: #ffffff"></i>
                </div>
                <p class="m-0 mt-2 text-center">Openings</p>
              </div>
            </div>
            <div class="main-box" routerLink="settings">
              <div class="d-grid justify-content-center">
                <div class="icon-box">
                  <i class="fa-solid fa-gears" style="color: #ffffff"></i>
                </div>
                <p class="m-0 mt-2 text-center">Setting</p>
              </div>
            </div>
          </div>
        </div>

        <div class="container upcoming-feature">
          <section id="upcoming-features" class="upcoming-features">
            <h2 class="text-center mb-4">Upcoming Features</h2>
            <div id="features-list" class="features-grid">
              <div *ngFor="let feature of futureEvents" class="feature-box">
                <div class="feature-icon">{{ feature.icon }}</div>
                <div class="feature-title">{{ feature.title }}</div>
                <div class="feature-description">{{ feature.description }}</div>
              </div>
            </div>
          </section>
          
         
          
          
        </div>
      </div>
    </div>
  </div>
</div>

}

<app-footer></app-footer>

<app-login-popup
  [displayStyle]="modalDisplayStyle"
  (myout)="GetChildData($event)"
></app-login-popup>
